import React, { useEffect, useState } from "react";
import "./adminBusinessManagement.css";
import { supabase, getBusinesses } from '../../supabase_client.jsx';

export function getApprovedBusinesses(businesses) {
  if (!businesses) return [];
  return businesses.filter(b => b.is_approved === true);
}

export function getPendingBusinesses(businesses) {
  if (!businesses) return [];
  return businesses.filter(b => b.is_approved !== true);
}

export function getReportedBusinesses(businesses) {
  if (!businesses) return [];
  return businesses.filter(b => b.is_reported === true);
}

export default function AdminBusinessManagement({ onViewSelect }) {
  const [businesses, setBusinesses] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [editBusiness, setEditBusiness] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [expandedLists, setExpandedLists] = useState({
    approved: false,
    pending: false,
    reported: false
  });

  async function getBusinesses() {
    const { data, error } = await supabase
      .from("users")
      .select("*")
      .eq("type", "Business");

    if (error) {
      console.error("Error fetching businesses:", error);
    } else {
      setBusinesses(data);
    }
  }

  {/** once business profile creation is set up and the businesses table is filled */}
  {/**
    async function getBusinesses() {
      const { data: users, error: userError } = await supabase
        .from("users")
        .select("*")
        .eq("type", "Business");

      const { data: bizData, error: bizError } = await supabase
        .from("businesses")
        .select("*");

      if (userError || bizError) {
        console.error(userError || bizError);
        return;
      }

      const merged = users.map(user => {
        const biz = bizData.find(b => b.user_id === user.user_id);
        return {
          ...user,
          address: biz?.address,
          bio: biz?.bio,
          website: biz?.website,
          business_name: biz?.name,
        };
      });

      setBusinesses(merged);
    }
    */}

  useEffect(() => {
    getBusinesses();
  }, []);

  const handleApprove = async () => {
    try {
      const { error } = await supabase
        .from("users")
        .update({ is_approved: true })
        .eq("id", editBusiness.id);

      if (error) { alert("Approve failed: " + error.message); return; }

      setBusinesses(prev =>
        prev.map(b => b.id === editBusiness.id ? { ...b, is_approved: true} : b)
      );
      setEditBusiness(null);
    } catch (err) {
      console.error(err);
    }
  };

  const handleUnapprove = async () => {
    try {
      const { error } = await supabase
        .from("users")
        .update({ is_approved: false })
        .eq("id", editBusiness.id); 

      if (error) { alert("Unapprove failed: " + error.message); return; } 

      setBusinesses(prev =>
        prev.map(b => b.id === editBusiness.id ? { ...b, is_approved: false} : b)
      );
      setEditBusiness(null);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async () => {
    try {
      const { error } = await supabase
        .from("users")
        .delete()
        .eq("id", editBusiness.id); 
      
      if (error) { alert("Delete failed: " + error.message); return; }

      setBusinesses(prev => prev.filter(b => b.id !== editBusiness.id));
      setEditBusiness(null);
      setDeleteConfirmation(false);
    } catch (err) {
      console.error(err);
    }
  };

  const getApprovedBusinesses = (businesses) => {
    if (!businesses) return [];
    return businesses.filter(
      (b) => b.is_approved === true
    );
  };

  const getPendingBusinesses = (businesses) => {
    if (!businesses) return [];
    return businesses.filter(
      (b) => b.is_approved === false
    );
  };

  const getReportedBusinesses = (businesses) => {
    if (!businesses) return [];
    return businesses.filter(
      (b) => b.is_reported === true
    );
  };

  const renderBusinessList = (businesses, listType) => {
    if (!businesses || businesses.length === 0) {
      return <p className="empty-state">No businesses</p>;
    }

    const isExpanded = expandedLists[listType];
    const visibleBusinesses = isExpanded? businesses: businesses.slice(0, 5);
    const extraCount = businesses.length - 5;

    return (
      <div className="event-list-wrapper">
        {visibleBusinesses.map(business => (
          <div key={business.id} className="user-item" onClick={() => setSelectedBusiness(business)}>
          <div className="user-text">
            <span className="user-name">{business.username}</span>
            <span className="user-location">{business.address}</span>
          </div>

          <span
            className="edit-icon"
            onClick={(e) => {
              e.stopPropagation();
              setEditBusiness(business);
            }}
           >
            ✎
          </span>

          </div>
        ))}
        
        {!isExpanded && extraCount > 0 && (
          <div
            className="expand-toggle"
            onClick={() => setExpandedLists(prev => ({...prev, [listType]: true}))} 
          >
            + {extraCount} more businesses
          </div>
        )}

        {isExpanded && extraCount > 0 && (
          <div
            className="collapse-toggle"
            onClick={() => setExpandedLists(prev => ({...prev, [listType]: false}))}
          >
            Collapse
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="business-management-container">
      <div className="home-card">
        {/* header */}
        <div className="calendar-top-nav">
            <div className="nav-left">
                <button className="nav-tab" onClick={() => onViewSelect('admin')}>
                    General
                </button>
                <button className="nav-tab" onClick={() => onViewSelect('adminCalendar')}>
                    Event Calendar
                </button>
                <button className="nav-tab" onClick={() => onViewSelect('adminKPIDash')}>
                  KPI Dashboard
                </button>
                <button className="nav-tab" onClick={() => onViewSelect('adminEventManagement')}>Event Management</button>
                <button className="nav-tab" onClick={() => onViewSelect('user-management')}>
                  User Management
                </button>
                <button className="nav-tab active">
                  Business Management
                </button>
                <button className="bpActionBtn secondary" onClick={() => {
                    sessionStorage.removeItem("currentUser");
                    sessionStorage.removeItem("currentView");
                    onViewSelect("loginSignup");
                  }}>
                    Log Out
                  </button>
            </div>

        </div>
        <div className="user-blocks-container">

            {/* approved users */}
            <div className="approved-users user-block">
                <h3>Approved Businesses</h3>
                {renderBusinessList(getApprovedBusinesses(businesses), "approved")}
            </div>

            <div className="right-column">
                {/* pending users */}
                <div className="pending-users user-block">
                    <h3>Pending Businesses</h3>
                    {renderBusinessList(getPendingBusinesses(businesses), "pending")}
                </div>

                {/* past users */}
                <div className="reported-users user-block">
                    <h3>Reported Businesses</h3>
                    {renderBusinessList(getReportedBusinesses(businesses), "reported")}
                </div>
            </div>
        </div>

        {/*user details popup */}
        {selectedBusiness && (
          <div className="popup-overlay" onClick={() => setSelectedBusiness(null)}>
            <div className="popup" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setSelectedBusiness(null)}>✕</button>

              <div className="popup-header">
                <div className="popup-avatar">{selectedBusiness.username?.[0]?.toUpperCase()}</div>
                <div>
                  <h2 className="popup-title">{selectedBusiness.username}</h2>
                  <span className={`popup-badge ${selectedBusiness.is_approved ? 'badge-approved' : 'badge-pending'}`}>
                    {selectedBusiness.is_approved ? 'Approved' : 'Pending'}
                  </span>
                </div>
              </div>

              <div className="popup-divider" />

              <div className="popup-details">
                {selectedBusiness.address && (
                  <div className="popup-row">
                    <span className="popup-label">Address</span>
                    <span className="popup-value">{selectedBusiness.address}</span>
                  </div>
                )}
                {selectedBusiness.website && (
                  <div className="popup-row">
                    <span className="popup-label">Website</span>
                    <a className="popup-value popup-link" href={selectedBusiness.website} target="_blank" rel="noreferrer">
                      {selectedBusiness.website}
                    </a>
                  </div>
                )}
                {selectedBusiness.bio && (
                  <div className="popup-row popup-row-col">
                    <span className="popup-label">Bio</span>
                    <span className="popup-value">{selectedBusiness.bio}</span>
                  </div>
                )}
                <div className="popup-row">
                  <span className="popup-label">Reported</span>
                  <span className="popup-value">{selectedBusiness.is_reported ? 'Yes' : 'No'}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/** edit popup */}
        {editBusiness && (
          <div className="admin-modal-overlay">
            <div className="admin-modal admin-modal-narrow">

              <button className="admin-close-btn" onClick={() => setEditBusiness(null)}>✕</button>

              <div className="admin-modal-header">
                <div className="popup-avatar popup-avatar-lg">{editBusiness.username?.[0]?.toUpperCase()}</div>
                <div>
                  <h2>{editBusiness.username}</h2>
                  <span className={`popup-badge ${editBusiness.is_approved ? 'badge-approved' : 'badge-pending'}`}>
                    {editBusiness.is_approved ? 'Approved' : 'Pending'}
                  </span>
                </div>
              </div>

              <div className="popup-divider" style={{ margin: '16px 0' }} />

              <div className="popup-details">
                {editBusiness.address && (
                  <div className="popup-row">
                    <span className="popup-label">Address</span>
                    <span className="popup-value">{editBusiness.address}</span>
                  </div>
                )}
                {editBusiness.website && (
                  <div className="popup-row">
                    <span className="popup-label">Website</span>
                    <a className="popup-value popup-link" href={editBusiness.website} target="_blank" rel="noreferrer">
                      {editBusiness.website}
                    </a>
                  </div>
                )}
                {editBusiness.bio && (
                  <div className="popup-row popup-row-col">
                    <span className="popup-label">Bio</span>
                    <span className="popup-value">{editBusiness.bio}</span>
                  </div>
                )}
              </div>

              <div className="admin-modal-footer">
                {editBusiness.is_approved ? (
                  // Approved → Unapprove + Delete
                  <>
                    <button className="admin-unpublish-btn" onClick={handleUnapprove}>
                      Unapprove
                    </button>
                    <button className="admin-delete-btn" onClick={() => setDeleteConfirmation(true)}>
                      Delete
                    </button>
                  </>
                ) : (
                  // Pending / Reported → Approve + Remove
                  <>
                    <button className="admin-approve-btn" onClick={handleApprove}>
                      Approve
                    </button>
                    <button className="admin-delete-btn" onClick={() => setDeleteConfirmation(true)}>
                      Remove
                    </button>
                  </>
                )}
              </div>

            </div>
          </div>
        )}

        {/* Delete confirmation */}
        {deleteConfirmation && (
          <div className="admin-modal-overlay">
            <div className="admin-modal admin-delete-confirmation">
              <h2>Confirm {editBusiness?.is_approved ? 'Delete' : 'Remove'}</h2>
              <p>
                Are you sure you want to {editBusiness?.is_approved ? 'delete' : 'remove'}{' '}
                <strong>{editBusiness?.username}</strong>? This cannot be undone.
              </p>
              <div className="admin-modal-footer">
                <button className="admin-cancel-btn" onClick={() => setDeleteConfirmation(false)}>Cancel</button>
                <button className="admin-confirm-delete-btn" onClick={handleDelete}>
                  Yes, {editBusiness?.is_approved ? 'Delete' : 'Remove'}
                </button>
              </div>
            </div>
          </div>
        )}

        </div>
    </div>
  );
}